var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.3 12.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M14.9 9.6L9.5 1C8.6-.3 6.6-.3 5.8 1L.3 9.6c-.9 1.4.2 3.2 1.9 3.2h10.9c1.7-.1 2.7-1.8 1.8-3.2zm-7.3 1.2c-.3 0-.6-.1-.7-.3-.2-.2-.3-.5-.3-.7 0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.3 0 .6.1.7.3.2.2.3.5.3.8 0 .3-.1.6-.3.8-.2.1-.5.2-.8.2zm1.1-4.1c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.7-.3-.2-.2-.3-.5-.3-.8V3.3c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.3 0 .6.1.7.3.2.2.3.5.3.8v3.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default ForwardRef;